module.exports = __webpack_public_path__ + "static/media/HelveticaNeue.739624a9.ttf";